import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import classNames from 'classnames';
import { t } from 'ttag';

import { FeedFilterTitle } from '@components/FeedFilterTitle';
import { CityForm } from '../../tutorial/components/CityForm';

export default class CityFilter extends Component {
  state = {
    isActive: true,
  };

  onClose = () => {
    this.props.eventStream.next({
      action: 'closeClicked',
      eventStream: this.props.eventStream,
    });
  };

  setCityFilter = (id) => {
    this.props.eventStream.next({
      action: 'setCityFilter',
      id,
    });
  };

  handleToggle = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };

  handleCityChange = (e) => {
    e.preventDefault();
    this.props.eventStream.next({
      action: 'cityChangeClicked',
      eventStream: this.props.eventStream,
      config: this.props.config,
    });
  };

  handleSubmit = (data) => {
    this.props.eventStream.next({
      action: 'cityFormSubmit',
      eventStream: this.props.eventStream,
      config: this.props.config,
      data,
    });
  };

  render() {
    return (
      (<div
        className={classNames(
          'b-filter__section',
          { 'b-filter__section_state_active': this.state.isActive },
        )}
      >
        <FeedFilterTitle
          title={t`Місто`}
          hide={!this.state.isActive}
          onClick={this.handleToggle}
        />
        <div className="b-filter__content">
          {this.props.userCity ?
            <div className="b-check-list__item">
              <input
                id="city"
                className="b-form-check-input"
                name="city"
                type="checkbox"
                checked={this.props.checked}
                onChange={() => this.setCityFilter(this.props.userCity.value)}
              />
              <label className="b-form-checkbox" htmlFor="city">
                {this.props.userCity.label.length > 17
                  ? `${this.props.userCity.label.slice(0, 17)}...`
                  : this.props.userCity.label}
              </label>
              <a
                role="button"
                style={{
                  float: 'right',
                  color: '#999',
                  fontSize: '14px',
                  outline: 'none',
                }}
                onClick={this.handleCityChange}
              >
                {t`змінити`}
              </a>
            </div>
            : (
              <a
                role="button"
                style={{ color: '#999', outline: 'none' }}
                onClick={this.handleCityChange}
              >
                {t`Вкажіть ваше місто`}
              </a>
            )}
        </div>
        <Modal
          isOpen={this.props.isCityModalOpen}
          onRequestClose={this.onClose}
          contentLabel="Modal"
          className="b-modal b-modal_maxw_300"
          overlayClassName="b-modal__overlay"
        >
          <CityForm
            initialValues={{
              city: this.props.userCity,
            }}
            onSubmit={this.handleSubmit}
          />
        </Modal>
      </div>)
    );
  }
}

CityFilter.propTypes = {
  isCityModalOpen: PropTypes.bool.isRequired,
  cities: PropTypes.array.isRequired,
  checked: PropTypes.bool.isRequired,
  config: PropTypes.object.isRequired,
  userCity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
